import { type ReactNode, useCallback, useEffect } from 'react';

import { useSearchParams } from 'react-router-dom';

import { type CampaignParams, resolveCampaignParams } from 'utils/campaign';
import { PersistService } from 'utils/persist';

type InjectCouponCodeProps = {
  children: ReactNode;
};

export function InjectCouponCode({ children }: InjectCouponCodeProps) {
  const [searchParams, setSearchParams] = useSearchParams();

  const check = useCallback(() => {
    const campaignParams = resolveCampaignParams(
      searchParams,
      PersistService.get<CampaignParams>('campaignParams') ?? undefined,
    );

    if (Object.keys(campaignParams).length > 0) {
      PersistService.set('campaignParams', campaignParams);
    }

    const couponCode = searchParams.get('extendCouponCode');

    if (couponCode) {
      PersistService.set('extend.coupon.code', couponCode);

      setSearchParams(
        (prev) => {
          prev.delete('extendCouponCode');

          return prev;
        },
        { replace: true },
      );
    }
  }, [searchParams, setSearchParams]);

  useEffect(() => {
    check();
  }, [check]);

  return children;
}
